import { render, staticRenderFns } from "./lucky_gift.vue?vue&type=template&id=3f512ceb&scoped=true"
import script from "./lucky_gift.vue?vue&type=script&lang=js"
export * from "./lucky_gift.vue?vue&type=script&lang=js"
import style0 from "./lucky_gift.vue?vue&type=style&index=0&id=3f512ceb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f512ceb",
  null
  
)

export default component.exports